export const VERSION = '4.20.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map